import { z } from 'zod';
import { AiProvenanceSchema } from '../../shared/ai-provenance';
import { BaseErrorSchema } from '../../shared/error.schema';
import { ProcessStepRecordingDisplaySchema } from '../../entities/process-step-recording/process-step-recording.schema';
export const GenerateStepRecordingSummaryRequestSchema = z.void();
export const GenerateStepRecordingSummaryResponseSchema = z.object({
    processStepRecording: ProcessStepRecordingDisplaySchema.nullable(),
    aiProvenance: AiProvenanceSchema.optional()
});
export const GenerateStepRecordingSummaryErrorSchema = BaseErrorSchema;

//# sourceMappingURL=generate-step-recording-summary.schema.js.map